import axios from "axios";
import { api_url } from "./constantInformation";
import {
  availableLeaguesCricket,
  convertToLocalDate,
  getCurrentSeasonForLeagueFromRC,
  getUserJwtToken,
  leagues2023,
} from "./utils";
import { TaskQueue } from "cwait";

const MAX_SIMULTANEOUS_CALL = 16;
async function getDataForAllPlatformLeague(platform, sport, isAdmin) {
  let dynamic_url = [];
  if (isAdmin) {
    dynamic_url = availableLeaguesCricket.map(
      (league) =>
        api_url + sport + "/slate/" + platform.toLowerCase() + "/" + league
    );
  } else {
    dynamic_url = availableLeaguesCricket.map(
      (league) =>
        api_url + sport + "/slate/" + platform.toLowerCase() + "/" + league
    );
  }
  console.log("getDataForAllPlatformLeague: ", dynamic_url);

  console.log("getDataForAllPlatformLeague: ", dynamic_url);

  const queue = new TaskQueue(Promise, MAX_SIMULTANEOUS_CALL);
  const jwtToken = await getUserJwtToken();
  const results = await Promise.all(
    dynamic_url.map(
      queue.wrap(
        async (url) =>
          await axios
            .get(url, {
              headers: {
                "Authorization": jwtToken
              },
            })
            .catch((error) => {
              console.error(error);
            })
      )
    )
  );

  console.log("Concurrent Results:: ", results);
  let final = {};
  if (isAdmin) {
    availableLeaguesCricket.forEach((league, index) => {
      final[league] = results[index];
    });
  } else {
    availableLeaguesCricket.forEach((league, index) => {
      final[league] = results[index];
    });
  }

  return final;
}

const fetchDataForPlatformAndLeague = async (platform, sport, league) => {
  const url = api_url + sport + "/slate/" + platform + "/" + league;
  const jwtToken = await getUserJwtToken();
  console.log("JWT Token: ", jwtToken);
  const result = await axios
    .get(url, {
      headers: {
        "Authorization": jwtToken
      },
    })
    .catch((error) => {
      console.error(error);
    });

  try{
    for (const league in result) {
      result[league].forEach(game => {
          game.slate_timeframe = convertToLocalDate(game.GameDateTime);
      });
    }
    
  }
  catch(e){
    console.error("Error in setting slate_timeframe to local time date. Error : ", e)
  }

  
    
  console.log("SINGLE API RESULT", result);
  return result.data;
};

const get_create_comment_url = (blogId) => {
  // return "http://localhost:5001" + "/blog/" + blogId + "/comment/create";
  return api_url + "/blog/" + blogId + "/comment/create";
};

function getEditBlogURL(blogID) {
  return api_url + "/blog/" + blogID;
  // return "http://localhost:5001/blogs/create";
}
function getCreateBlogURL() {
  return api_url + "/blogs/create";
  // return "http://localhost:5001/blogs/create";
}

function get_player_projections_for_slate_id(sport, league, slate_id, ssid) {
  return (
    api_url +
    sport +
    "/" +
    encodeURIComponent(league) +
    "/projections/" +
    encodeURIComponent(slate_id) +
    "/" +
    encodeURIComponent(ssid)
  );
}
function get_player_projections_current(sport, league, ssid, dateTime) {
  return (
    api_url +
    sport +
    "/" +
    encodeURIComponent(league) +
    "/projections/" +
    encodeURIComponent(ssid) +
    "/" +
    encodeURIComponent(dateTime) +
    "/current"
  );
}
function get_player_stats_actual_current_season(
  sport,
  league,
  ssid,
  dateTime,
  rc
) {
  // hard coded 2021????
  const season = getCurrentSeasonForLeagueFromRC(league, rc);
  return (
    api_url +
    sport +
    "/" +
    encodeURIComponent(league) +
    // "/playerstats/2022/" +
    "/playerstats/" +
    season +
    "/" +
    encodeURIComponent(dateTime) +
    "/" +
    encodeURIComponent(ssid)
  );
}
function get_player_gamelogs_current_season(sport, league, ssid, dateTime, rc) {
  const season = getCurrentSeasonForLeagueFromRC(league, rc);
  return (
    api_url +
    sport +
    "/" +
    encodeURIComponent(league) +
    // "/gamelogs/2022/" +
    "/gamelogs/" +
    season +
    "/" +
    encodeURIComponent(dateTime) +
    "/" +
    encodeURIComponent(ssid)
  );
}

function get_auto_lineups() {
  return api_url + "/lineups/auto";
}

function get_recommendation_lineups_url() {
  return api_url + "/lineups/scenario/all";
}

export {
  getDataForAllPlatformLeague,
  fetchDataForPlatformAndLeague,
  get_player_projections_for_slate_id,
  get_player_projections_current,
  get_player_stats_actual_current_season,
  get_player_gamelogs_current_season,
  get_auto_lineups,
  get_recommendation_lineups_url,
  get_create_comment_url,
  getCreateBlogURL,
  getEditBlogURL,
};
